import type { BboxCenter } from "./types";

export const bboxCenter: BboxCenter = ({ bbox }) => ({
  x: (bbox.x1 + bbox.x2) / 2,
  y: (bbox.y1 + bbox.y2) / 2,
});
